import { getOneTimePrice } from '../container/DeviceDetail/helpers/promoPriceHelper';
import mountOptionPicker from './mountOptionPicker';
import {
    IOptionPickerCapacityItem,
    OptionPickerItemState,
    OPTION_PICKER_TYPE_CAPACITY,
} from '@vfde-brix/option-picker';
import { Price } from '@vfde-brix/core';
import { CAPACITY_KEY } from '../container/Options/constants';
import { StateProps } from 'app/container/Options/interfaces/state';
import { Atomic, Capacity } from 'app/container/DeviceDetail/interfaces/api';

/**
 * Mount the color picker
 *
 * @param containerId
 * @param capacities
 * @param currentCapacity
 * @param availableCapacities
 * @param isHardwareOnly
 * @param onChangeAction
 */
export const mountCapacityOptionPicker = (containerId: string, { capacities, currentCapacity, availableCapacities = [], isHardwareOnly }: StateProps, onChangeAction?: (value: number) => void) => {
    const availableSizes = availableCapacities.map(capacity => capacity[CAPACITY_KEY]);
    const items: IOptionPickerCapacityItem[] = [];

    for (const [index, capacity] of capacities!.entries()) {
        let state: OptionPickerItemState | undefined;

        switch (true) {
            case (!availableSizes.includes(capacity[CAPACITY_KEY])):
                state = 'disabled';
                break;
            case (currentCapacity === capacity[CAPACITY_KEY] || index === 0):
                state = 'checked';
                break;
        }

        items.push({
            stdValue: `${capacity[CAPACITY_KEY]}`,
            stdCapacity: `${capacity.size}`,
            price: getItemPrice(availableCapacities, capacity, isHardwareOnly),
            optState: state,
        });
    }

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        onChangeAction && onChangeAction(Number(target.value));
    };

    return mountOptionPicker(containerId, 'capacity-picker', OPTION_PICKER_TYPE_CAPACITY, items, onChange);
};

/**
 * Get item price
 *
 * @param availableCapacities
 * @param capacity
 * @param isHardwareOnly
 */
const getItemPrice = (availableCapacities: Atomic[], capacity: Capacity, isHardwareOnly: boolean): Price => {
    // Capacity picker should show correct prices with or without addon.
    // If capacity is not available for one color, we read price from root capacities object
    const [availableCapacity] = availableCapacities.filter(filteredCapacity => filteredCapacity[CAPACITY_KEY] === capacity[CAPACITY_KEY]);
    const priceFromCapacity = availableCapacity ? availableCapacity : capacity;
    const oneTimeprice = getOneTimePrice(priceFromCapacity, isHardwareOnly);

    return Price.fromNumber(oneTimeprice!);
};
